export { default } from './Adimo';
